export const NOTE_STATE = {
  LOADING: "LOADING",
  NOT_PLAYED: "NOT_PLAYED",
  PLAYING: "PLAYING",
  PAUSED: "PAUSED",
  STOPPED: "STOPPED"
};

export default NOTE_STATE;
